<template>
  <div class="not-allowed">
    <h1>ไม่อนุญาตให้เข้าถึงหน้านี้</h1>
  </div>
</template>

<script>
export default {
  name: "NotAllowed",
};
</script>

<style scoped>
.not-allowed {
  text-align: center;
  margin-top: 100px;
}
</style>
